export default "__VITE_ASSET__c29969a2__"